module.exports = __webpack_public_path__ + "img/manual-1.ec9b1504.png";